import React, { useState } from 'react';
import { get } from 'lodash';
import moment from 'moment';
import Waypoint from 'react-waypoint';
import axios from 'axios';
import Loading from '../../Loading';

const ExternalTransactions = ({walletId, chain}) => {
  const [isLoading, setLoading] = useState(true)
  const [shouldFetch, setShouldFetch] = useState(true)
  const [externalLogs, setExternalLogs] = useState([])

  const fetchData = () => {
    if (shouldFetch) {
      axios.get(`/${gon.currentProvider}/api/wallets/${walletId}/transactions/external?chain=${chain.toLowerCase()}`)
      .then((res) => {
        if (res.status == 200 && get(res, 'data.external_logs')) {
          setExternalLogs(res.data.external_logs)
          setShouldFetch(false)
          setLoading(false)
        }
      })
    }
  }

  return (
    <Waypoint onEnter={fetchData}>
      <div>
        <div className='User__header Table--wallet-transactions-header'>
          <h4 className='User__header__h4'>External {chain}</h4>
        </div>
        <div className='Table Table--wallet-transactions-external'>
          <div className='Table__row'>
            <div className='Table__col Table__col--th'>Description</div>
            <div className='Table__col Table__col--th'>Status</div>
            <div className='Table__col Table__col--th'>Amount</div>
            <div className='Table__col Table__col--th'>Currency</div>
            <div className='Table__col Table__col--th'>Hash</div>
            <div className='Table__col Table__col--th'>Token ID</div>
            <div className='Table__col Table__col--th'>Created At</div>
          </div>

          <Loading
            isLoading={isLoading && externalLogs.length == 0}
          >
            {externalLogs.map((transaction) => (
              <div key={transaction.id} className='Table__row'>
                <div className='Table__col'>{transaction.description}</div>
                <div className='Table__col'>{transaction.status}</div>
                <div className='Table__col'>{parseInt(transaction.amount).toLocaleString()}</div>
                <div className='Table__col'>{transaction.currency}</div>
                <div className='Table__col'>{transaction.hash}</div>
                <div className='Table__col'>{transaction.token_id}</div>
                <div className='Table__col'>{moment.unix(transaction.created_at).format('YYYY-MM-DD HH:mm')}</div>
              </div>
            ))}
          </Loading>
        </div>
      </div>
    </Waypoint>
  )
}

export default ExternalTransactions
